// Use this file to override the default configuration

import { type PartialDeep } from 'type-fest';

import { type DefaultConfig } from './default.config';

export const defaultProdConfig: PartialDeep<DefaultConfig> = {
    consoleLogLevel: 'info',
    sentry: {
        environment: 'prod',
        logLevel: 'info',
        sampleRate: 0.1
    }
};
